<template>
    <div class="w100 bgGrey">
        <div class="top">
            <img src="../../assets/images/record_1.png" alt="" class="w100">
            <img src="../../assets/images/record_2.png" alt="" class="big-data-img">
        </div>
        <article class="wContent center">
            <div class="mw-modular-box textCenter" style="margin: 50px 0;">
                <img src="../../assets/images/record_3.png" alt="">
            </div>
            <div class="mw-modular-box">
                <div class="inlineBlock bottom-1 vMid">
                    <h3 class="title fontWhite font20">唐宋100指数数据包</h3>
                    <p class="fontWhite font14 content">
                        主要提供钢铁行业基准价、开工率(按产能/按个数)、库存(<br>厂库/社库)、成本(调查/模型)近1-5年数据，<br>
                        涉及品种有铁矿石、焦炭、煤炭、废钢、合金、钢坯、螺纹<br>钢、线材、板材、带钢、型钢、管材等。<br>
                        服务形式:以excel表格形式为主。
                    </p>
                </div>
                <div class="inlineBlock bottom-2 vMid">
                    <h3 class="title fontWhite font20">数据API接口服务</h3>
                    <p class="fontWhite font14 content">以API接口形式提供数据服务</p>
                </div>
            </div>
            <div class="mw-modular-box">
                <div class="inlineBlock bottom-3 vMid">
                    <h3 class="title fontWhite font20">小样本数据</h3>
                    <p class="fontWhite font14 content">
                        根据客户需求选择部分样本企业计算<br>出的指标数据。
                    </p>
                </div>
                <div class="inlineBlock bottom-4 vMid">
                    <h3 class="title fontWhite font20">定制数据</h3>
                    <p class="fontWhite font14 content">提供客户个性化需求的数据。</p>
                </div>
            </div>
        </article>
        <div id="concats">
            <ConcatsControl></ConcatsControl>
        </div>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import $ from 'jquery'
export default {
    name: 'Record',
    components: { ConcatsControl },
    data () {
        return {
        }
    },
    mounted () {
        // 初始化内容
        this.scrollEvent();
    },
    methods: {
        //页面操作
        scrollEvent (e) {
            const self = this;
            $('#concats').hide();
            $(document).scroll(function() {
                var scroH = $(document).scrollTop();  //滚动高度
                // var viewH = $(window).height();  //可见高度 
                // var contentH = $(document).height();  //内容高度
                // console.log(scroH, viewH, contentH)
                if(scroH > 200){  //距离顶部大于100px时
                    $('#concats').show(500)
                } else {
                    $('#concats').hide(500)
                }
                // if (contentH - (scroH + viewH) <= 100){  //距离底部高度小于100px
                    
                // }  
                // if (contentH = (scroH + viewH)){  //滚动条滑到底部啦
                    
                // }  
        
            });
        }
    },
}
</script>

<style scoped>
    .top { position: relative; }
    .top .big-data-img { position: absolute; left: 50%; top: 50%; margin-left: -332px; margin-top: -80px; }
    .bottom-1, .bottom-4 { box-sizing: border-box; padding: 40px 80px; width: 740px; height: 310px; background: url('../../assets/images/record_4.png') no-repeat; background-size: 100% 100%; margin-right: 26px; }
    .bottom-2, .bottom-3 { box-sizing: border-box; padding: 40px 80px; width: 433px; height: 310px; background: url('../../assets/images/record_5.png') no-repeat; background-size: 100% 100%; }
    .bottom-4 { background: url('../../assets/images/record_7.png') no-repeat; background-size: 100% 100%; margin-right: 0; }
    .bottom-3 { background: url('../../assets/images/record_6.png') no-repeat; background-size: 100% 100%; margin-right: 26px; }
    .title { line-height: 50px; }
    .content { line-height: 30px; }
</style>